import axios from 'axios';
import { Dispatch } from 'redux';
import { WarehouseAction, WarehouseTypes } from '../../types/warehouse';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

export const getWarehouseData =
  (date?: string) => async (dispatch: Dispatch<WarehouseAction | any>) => {
    const query = date ? `?date=${date}` : '';
    try {
      dispatch({
        type: WarehouseTypes.SET_WAREHOUSE_LOADING,
      });

      const res = await axios.get(`/api/warehouse${query}`);

      dispatch({
        type: WarehouseTypes.GET_WAREHOUSE_DATA,
        payload: res.data,
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: WarehouseTypes.GET_WAREHOUSE_DATA,
        payload: {
          byZones: [],
          noVolume: [],
        },
      });
    }
  };

export const getWarehouseForecast =
  (date: string) => async (dispatch: Dispatch<WarehouseAction | any>) => {
    try {
      const res = await axios.get(`/api/warehouse/forecast?date=${date}`);

      dispatch({
        type: WarehouseTypes.GET_WAREHOUSE_FORECAST,
        payload: res.data,
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: WarehouseTypes.GET_WAREHOUSE_FORECAST,
        payload: [],
      });
    }
  };

export const setWarehouseForecast =
  (coef: number | null) => async (dispatch: Dispatch<WarehouseAction>) => {
    dispatch({
      type: WarehouseTypes.SET_WAREHOUSE_FORECAST,
      payload: coef,
    });
  };

export const clearWarehouse =
  () => async (dispatch: Dispatch<WarehouseAction>) => {
    dispatch({
      type: WarehouseTypes.CLEAR_WAREHOUSE,
    });
  };
